import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

import { classNames } from 'support/helpers/generic/generic';
import { Image } from 'components/Image/Image';
import { ApplicationLogoSmall } from 'components/Logo/ApplicationLogoSmall/ApplicationLogoSmall';

const sizeClasses = {
  wrapper: {
    small: 'w-6 h-6',
    base: 'w-10 h-10',
    large: 'w-12 h-12',
  },
  image: {
    small: 'w-3 h-3',
    base: 'w-7 h-7',
    large: 'w-9 h-9',
  },
};

type SIZE_VARIANTS = 'small' | 'base' | 'large';

export const PartnerLogo = ({
  imageUrl,
  size = 'base',
  fullSize = false,
  isLoading = false,
  knownPartner = true,
  className,
  imageClassName,
}: {
  imageUrl: string | undefined | null;
  isLoading?: boolean;
  size?: SIZE_VARIANTS;
  fullSize?: boolean;
  knownPartner?: boolean;
  className?: string;
  imageClassName?: string;
}) => {
  const wrapperClasses = fullSize
    ? 'flex-shrink-0 flex items-center justify-center overflow-hidden'
    : 'flex-shrink-0 border border-gray-200 bg-white rounded flex items-center justify-center overflow-hidden';
  const imageClasses = fullSize ? 'h-full w-full' : 'object-contain';

  if (isLoading) {
    return (
      <PartnerLogoSkeleton
        className={classNames(fullSize ? sizeClasses.wrapper[size] : sizeClasses.image[size], className)}
      />
    );
  }

  return (
    <div className={classNames(sizeClasses.wrapper[size], wrapperClasses, className)}>
      {knownPartner ? (
        imageUrl ? (
          <Image
            className={classNames(sizeClasses.image[size], imageClasses, imageClassName)}
            src={imageUrl}
            alt=""
            fallback={<ApplicationLogoSmall className={sizeClasses.image[size]} />}
          />
        ) : (
          <ApplicationLogoSmall className={sizeClasses.image[size]} />
        )
      ) : (
        <UnkownPartnerLogo className={sizeClasses.image[size]} />
      )}
    </div>
  );
};

const PartnerLogoSkeleton = ({ className }: { className: string }) => {
  return <div className={classNames('leading-relaxed animate-pulse bg-gray-200 rounded shrink-0', className)} />;
};

const UnkownPartnerLogo = ({ className }: { className: string }) => {
  return (
    <div
      className={classNames(
        'flex items-center justify-center text-gray-400 bg-gray-50 rounded shrink-0 w-full h-full',
        className,
      )}
    >
      <QuestionMarkCircleIcon className={className} />
    </div>
  );
};
